export const ACCESS_TOKEN = 'yescapaAPI_access_token'
export const REFRESH_ACCESS_TOKEN = 'yescapaAPI_refresh_token'
